import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import guLocale from "../locales/gu"; 

const ConfirmationModal = ({ show, title, message, onConfirm, onCancel }) => {
  const locale = guLocale.confirmationModal;

  return(
  <Modal show={show} onHide={onCancel} centered>
    <Modal.Header>
      <Modal.Title>{title || locale.defaultTitle}</Modal.Title>
        <button className="close" data-dismiss="modal" aria-label="Close" onClick={onCancel}>
            <span aria-hidden="true">&times;</span>
        </button>
    </Modal.Header>
    <Modal.Body>
      <p>{message || locale.defaultMessage}</p>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={onCancel}>{locale.cancelButtonText}</Button>
      <Button variant="danger" onClick={onConfirm}>{locale.confirmButtonText}</Button>
    </Modal.Footer>
  </Modal>
  )
};

export default ConfirmationModal;